/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compliance_Copilot_Threshold_HelperInputs */



/**
* | output |
* | --- |
* | "The default confidence is 80%. Higher values reduce false positives, lower values increase coverage." |
*
* @param {Compliance_Copilot_Threshold_HelperInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compliance_copilot_threshold_helper = /** @type {((inputs?: Compliance_Copilot_Threshold_HelperInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compliance_Copilot_Threshold_HelperInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Standard-Konfidenz beträgt 80%. Höhere Werte reduzieren Fehlalarme, niedrigere Werte erhöhen die Abdeckung.")
	return /** @type {LocalizedString} */ ("The default confidence is 80%. Higher values reduce false positives, lower values increase coverage.")
});